// Mobile nav drawer toggle
const whHeader = document.getElementById('whHeader');
const whNavToggle = document.getElementById('whNavToggle');
const whNavDrawer = document.getElementById('whNavDrawer');
if (whHeader && whNavToggle && whNavDrawer) {
  whNavToggle.addEventListener('click', () => {
    const isOpen = whHeader.classList.toggle('is-menu-open');
    whNavToggle.setAttribute('aria-expanded', String(isOpen));
    whNavDrawer.setAttribute('aria-hidden', String(!isOpen));
  });
}

// Header search overlay — opens on the search icon, closes on: the cancel
// button, the backdrop, or pressing Escape.
const whSearchToggle = document.getElementById('whSearchToggle');
const whSearch = document.getElementById('whSearch');
const whSearchCancel = document.getElementById('whSearchCancel');
const whSearchBackdrop = document.getElementById('whSearchBackdrop');
if (whSearchToggle && whSearch) {
  function setSearchOpen(open) {
    whSearch.hidden = !open;
    whSearchToggle.setAttribute('aria-expanded', String(open));
    if (open) {
      const input = whSearch.querySelector('input[type="search"]');
      if (input) input.focus();
    }
  }

  whSearchToggle.addEventListener('click', () => setSearchOpen(whSearch.hidden));
  if (whSearchCancel) whSearchCancel.addEventListener('click', () => setSearchOpen(false));
  if (whSearchBackdrop) whSearchBackdrop.addEventListener('click', () => setSearchOpen(false));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !whSearch.hidden) {
      setSearchOpen(false);
      whSearchToggle.focus();
    }
  });
}

// Hero image carousel
document.querySelectorAll('[data-carousel]').forEach((carousel) => {
  const track = carousel.querySelector('.carousel__track');
  const slides = Array.from(carousel.querySelectorAll('.carousel__slide'));
  const prevBtn = carousel.querySelector('[data-carousel-prev]');
  const nextBtn = carousel.querySelector('[data-carousel-next]');
  const currentEl = carousel.querySelector('[data-carousel-current]');
  const totalEl = carousel.querySelector('[data-carousel-total]');
  let index = 0;

  if (totalEl) totalEl.textContent = String(slides.length);

  function render() {
    track.style.transform = `translateX(-${index * 100}%)`;
    if (currentEl) currentEl.textContent = String(index + 1);
  }

  function go(delta) {
    index = (index + delta + slides.length) % slides.length;
    render();
  }

  if (prevBtn) prevBtn.addEventListener('click', () => go(-1));
  if (nextBtn) nextBtn.addEventListener('click', () => go(1));

  render();
});

// Featured carousel (home hero) — slide + dot + counter version used by
// wh-hero.liquid's .wh-feat component.
document.querySelectorAll('[data-feat-carousel]').forEach((carousel) => {
  const slides = Array.from(carousel.querySelectorAll('.wh-feat__slide'));
  const dots = Array.from(carousel.querySelectorAll('.wh-feat__dot'));
  const prevBtn = carousel.querySelector('[data-feat-prev]');
  const nextBtn = carousel.querySelector('[data-feat-next]');
  const currentEl = carousel.querySelector('[data-feat-current]');
  let index = 0;

  function render() {
    slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
    dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
    if (currentEl) currentEl.textContent = String(index + 1).padStart(2, '0');
  }

  function go(delta) {
    if (!slides.length) return;
    index = (index + delta + slides.length) % slides.length;
    render();
  }

  if (prevBtn) prevBtn.addEventListener('click', () => go(-1));
  if (nextBtn) nextBtn.addEventListener('click', () => go(1));
  dots.forEach((dot, i) => dot.addEventListener('click', () => { index = i; render(); }));

  render();
});

// Plan picker (.wh-plan / .wh-join-plan buttons) — selectable plan cards.
// Each button carries data-price / data-period / data-cart-url (or
// data-selling-plan on product pages) instead of a real radio input.
document.querySelectorAll('[data-plan-picker]').forEach((picker) => {
  const section = picker.closest('section') || picker.closest('[data-section-id]');
  const cta = section ? section.querySelector('[data-plan-cta]') : null;
  const ctaLabel = (cta && cta.dataset.ctaLabel) || 'Start my membership';
  const finalCtas = Array.from(document.querySelectorAll('[data-plan-cta-final]'));
  const buttons = Array.from(picker.querySelectorAll('.wh-plan, .wh-join-plan'));

  function applySelection(button) {
    buttons.forEach((b) => b.classList.toggle('is-active', b === button));
    if (!button) return;
    const price = button.dataset.price;
    const period = button.dataset.period;
    if (cta) {
      if (price) cta.textContent = `${ctaLabel} — ${price}${period || ''} →`;
      if (button.dataset.cartUrl) cta.setAttribute('href', button.dataset.cartUrl);
    }
    finalCtas.forEach((el) => {
      if (price) el.textContent = `Start my membership — ${price}${period || ''}`;
      if (button.dataset.cartUrl) el.setAttribute('href', button.dataset.cartUrl);
    });
  }

  buttons.forEach((button) => {
    button.addEventListener('click', () => applySelection(button));
  });

  applySelection(buttons.find((b) => b.classList.contains('is-active')) || buttons[0]);
});

// Product-page selling-plan picker — syncs the hidden `selling_plan` cart
// field and the visible price with whichever plan button is selected.
document.querySelectorAll('form[id^="AddToCartForm-"] [data-plan-picker]').forEach((picker) => {
  // Read the section id off the wrapping container's data attribute rather
  // than form.id — a form containing a field named "id" (our variant
  // <select name="id">) shadows HTMLFormElement.id with that field.
  const sectionId = picker.closest('[data-section-id]').dataset.sectionId;
  const hiddenInput = document.getElementById(`SellingPlanInput-${sectionId}`);
  const priceEl = document.getElementById(`ProductPrice-${sectionId}`);
  const buttons = Array.from(picker.querySelectorAll('.wh-plan'));

  function applySellingPlan(button) {
    if (!button) return;
    if (hiddenInput) hiddenInput.value = button.dataset.sellingPlan || '';
    if (priceEl && button.dataset.priceText) priceEl.textContent = button.dataset.priceText;
  }

  buttons.forEach((button) => {
    button.addEventListener('click', () => applySellingPlan(button));
  });
});

// FAQ accordion
document.querySelectorAll('.wh-faq').forEach((list) => {
  const items = Array.from(list.querySelectorAll('.wh-faq__item'));
  items.forEach((item) => {
    const question = item.querySelector('.wh-faq__q');
    question.addEventListener('click', () => {
      const willOpen = !item.classList.contains('is-open');
      items.forEach((i) => i.classList.remove('is-open'));
      if (willOpen) item.classList.add('is-open');
    });
  });
});

// Note: the #SortBy select's change handling is already wired up by
// Venture's own theme.js (CollectionSort) — nothing to add here.
